import React from "react";
import { ReactController } from "../react_controller";
import { VenueCalendar } from "../../components/Calendar/VenueCalendar";

export class AdminVenueCalendarController extends ReactController {
  connect() {
    this.root.render(<VenueCalendar {...this.propsValue} />);
  }
}
